<template>
  <div class="techPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/04/5711239710790026098.jpeg"
        alt=""
      />
    </div>

    <div class="group-layout group-layout-1 flex-rowl">
      <div class="media-section">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/03/5599323952409609436.png"
          alt=""
        />
      </div>
      <div class="text-section">
        <h1 class="main-title">{{ $t('tech.techProfessional.title1') }}</h1>
        <br />
        <p class="sub-title-2">{{ $t('tech.techProfessional.subtitle1') }}</p>
        <p class="content" v-html="$t('tech.techProfessional.content1')"></p>
        <br /><br />
        <p class="sub-title-2">{{ $t('tech.techProfessional.subtitle2') }}</p>
        <p class="content" v-html="$t('tech.techProfessional.content2')"></p>
        <br /><br />
        <p class="sub-title-2">{{ $t('tech.techProfessional.subtitle3') }}</p>
        <p class="content">{{ $t('tech.techProfessional.subtitle4') }}</p>
        <br /><br />
        <p class="content" v-html="$t('tech.techProfessional.content3')"></p>
      </div>
    </div>
    <div class="group-layout group-layout-2 flex-rowl">
      <div class="text-section">
        <h1 class="main-title">{{ $t('tech.globalCooperation.title1') }}</h1>
        <h1 class="sub-title-2">{{ $t('tech.globalCooperation.subtitle1') }}</h1>
        <div class="main-content">
          <h1 class="main-title">{{ $t('tech.globalCooperation.mibelleTitle') }}</h1>
          <p class="content">{{ $t('tech.globalCooperation.mibelleContent') }}</p>
          <br /><br />
          <h1 class="main-title">{{ $t('tech.globalCooperation.crbTitle') }}</h1>
          <p class="content">{{ $t('tech.globalCooperation.crbContent') }}</p>
        </div>
      </div>
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/03/4671140486630614563.png"
          alt=""
        />
      </div>
    </div>

    <div class="group-layout group-layout-3 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5542491209662508161.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="main-title">{{ $t('tech.naturalExtract.title1') }}</h1>
        <h1 class="sub-title-1">{{ $t('tech.naturalExtract.subtitle1') }}</h1>
        <p class="content" v-html="$t('tech.naturalExtract.content1')"></p>
      </div>
    </div>
    <div class="group-layout group-layout-4 flex-rowl">
      <div class="text-section">
        <h1 class="main-title">{{ $t('tech.researchCraftsmanship.title1') }}</h1>
        <h1 class="sub-title-1">{{ $t('tech.researchCraftsmanship.subtitle1') }}</h1>
        <p class="content" v-html="$t('tech.researchCraftsmanship.content1')"></p>
      </div>
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5039384516687410805.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
    </div>

    <div class="other_wrap">
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">{{ $t('tech.otherContent.title1') }}</div>
        <p class="txt1">{{ $t('tech.otherContent.subtitle1') }}</p>
        <div class="txt">
          <p v-html="$t('tech.otherContent.content1')"></p>
          <p v-html="$t('tech.otherContent.content2')"></p>
        </div>
        <p class="txt2">{{ $t('tech.otherContent.subtitle2') }}</p>
        <div class="txt">
          <p>{{ $t('tech.otherContent.content3') }}</p>
          <p>{{ $t('tech.otherContent.content4') }}</p>
        </div>
      </div>
    </div>

    <div class="group-layout group-layout-5">
      <div class="group-layout-container flex-rowl">
        <div class="media-section image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/03/5514280874527803054.png"
            alt=""
            class="zoomable-image"
          />
        </div>
        <div class="text-section">
          <h1 class="main-title">{{ $t('tech.bioDelivery.title1') }}</h1>
          <h1 class="sub-title-1">{{ $t('tech.bioDelivery.subtitle1') }}</h1>
          <p class="content mb_50" v-html="$t('tech.bioDelivery.content1')"></p>
          <h1 class="sub-title-1">{{ $t('tech.bioDelivery.subtitle2') }}</h1>
          <p class="content" v-html="$t('tech.bioDelivery.content2')"></p>
        </div>
      </div>
      <div class="group-layout-list flex-rowc">
        <div class="group-layout-item">
          <p class="main-title">{{ $t('tech.alpineMatrix.title1') }}</p>
          <p class="main-subtitle">{{ $t('tech.alpineMatrix.subtitle1') }}</p>
          <p class="main-txt" v-html="$t('tech.alpineMatrix.content1')"></p>
        </div>
        <div class="group-layout-item">
          <p class="main-title">{{ $t('tech.alpineMatrix.title2') }}</p>
          <p class="main-subtitle">{{ $t('tech.alpineMatrix.subtitle2') }}</p>
          <p class="main-txt" v-html="$t('tech.alpineMatrix.content2')"></p>
        </div>
      </div>
      <div class="text-section">
        <h1 class="main-title">
          {{ $t('tech.brandPhilosophy.title1') }}
        </h1>
        <p class="content">{{ $t('tech.brandPhilosophy.content1') }}</p>
        <br /><br />
        <h1 class="main-title">{{ $t('tech.brandPhilosophy.title2') }}</h1>
        <p class="content">{{ $t('tech.brandPhilosophy.content2') }}</p>
      </div>
    </div>

    <div class="join_wrap">
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">
          <p class="txt1 f-times-new-roman">{{ $t('join.title1') }}</p>
          <p class="txt2 f-source-han-serif-cn-M">{{ $t('join.title2') }}</p>
          <p class="txt3 f-source-han-serif-cn-M">{{ $t('join.title3') }}</p>
        </div>
        <div class="txt">
          <p>{{ $t('join.desc1') }}</p>
          <p>{{ $t('join.desc2') }}</p>
        </div>
        <div class="more flex-rowc" @click="handleGo('ProductPage')">{{ $t('join.more') }}</div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "TechPage",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleGo(link) {
      this.$router.push(link);
    },
  },
};
</script>
  <style lang="less">
.techPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    // height: 600px;
    margin-bottom: 110px;
  }
  .group-layout {
    align-items: flex-start;
    .main-title {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .sub-title-1 {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .sub-title-2 {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .main-subtitle {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .title {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
    .content {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .spec {
      font-size: 36px;
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .main-txt {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .more-details {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    p {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    .more {
      font-family: "SourceHanSansCN-Light", sans-serif;
    }
    &.group-layout-1 {
      box-sizing: border-box;
      padding: 0 430px 0 222px;
      .media-section {
        width: 592px;
        height: 848px;
        margin-right: 50px;
      }
      .text-section {
        margin-top: 34px;
        .sub-title-1 {
          margin-bottom: 10px;
        }
        .sub-title-2 {
          margin: 10px 0 10px;
        }
      }
    }
    &.group-layout-2 {
      margin: 78px auto 150px;
      .media-section {
        width: 930px;
        height: 730px;
      }
      .text-section {
        padding: 65px 165px 0 280px;
        box-sizing: border-box;
        .sub-title-2 {
          margin-top: 10px;
        }
        .main-content {
          margin-top: 40px;
          .main-title {
            margin-bottom: 29px;
          }
        }
      }
    }
    &.group-layout-3 {
      box-sizing: border-box;
      padding: 0 430px 0 280px;
      .media-section {
        width: 640px;
        height: 360px;
        margin-right: 85px;
      }
      .text-section {
        .sub-title-1 {
          margin: 15px 0 35px;
        }
      }
    }
    &.group-layout-4 {
      box-sizing: border-box;
      padding: 0 360px 0 280px;
      margin: 140px auto;
      .media-section {
        width: 640px;
        height: 360px;
        margin-left: 40px;
        flex-shrink: 0;
      }
      .text-section {
        .sub-title-1 {
          margin: 10px 0 30px;
        }
      }
    }
    &.group-layout-5 {
      color: #000000;
      padding: 0 370px 118px 280px;
      box-sizing: border-box;
      .group-layout-container {
        align-items: flex-start;
        .media-section {
          width: 640px;
          height: 360px;
          margin-right: 86px;
        }
        .text-section {
          margin-top: 0;
          .main-title {
            margin-bottom: 35px;
          }
          .sub-title-1 {
            margin-bottom: 10px;
          }
          .content {
            line-height: 27px;
          }
          .mb_50 {
            margin-bottom: 50px;
          }
        }
      }
      .group-layout-list {
        margin: 130px 0 107px;
        align-items: flex-start;
        .group-layout-item {
          position: relative;
          &:last-child {
            margin-left: 238px;
            &::after {
              width: 0;
              height: 282px;
              border-right: 1px dashed #000000;
              display: inline-block;
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: -120px;
            }
          }
          .main-title {
            font-size: 36px;
          }
          .main-subtitle {
            font-size: 26px;
            margin: 19px 0 34px;
          }
          .main-txt {
            font-size: 18px;
            line-height: 27px;
          }
        }
      }

      .text-section {
        margin-top: 107px;
        .main-title {
          margin-bottom: 25px;
        }
      }
    }
    .media-section {
      flex-shrink: 0;
    }
    .text-section {
      color: #000000;
      .main-title {
        font-size: 36px;
      }
      .sub-title-1 {
        font-size: 28px;
      }
      .sub-title-2 {
        font-size: 26px;
      }
      .content {
        font-size: 18px;
        line-height: 26px;
      }
      .spec {
        font-size: 36px;
      }
      .highlight {
        font-size: 22px;
        font-weight: bold;
      }
      .more-details {
        width: 450px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        color: #000000;
        margin-top: 59px;
      }
    }
  }
  .other_wrap {
    position: relative;
    margin-bottom: 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/03/5227416754654129227.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    .content {
      width: 695px;
      align-items: flex-start;
      color: #000000;
      .title {
        font-size: 36px;
        white-space: nowrap;
      }
      .txt1 {
        font-size: 26px;
        margin: 3px 0 50px;
      }
      .txt2 {
        font-size: 36px;
      }

      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
  }
  .join_wrap {
    position: relative;
    margin-bottom: 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/04/5175367247852106837.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    .content {
      width: 695px;
      align-items: flex-start;
      .title {
        color: #000000;
        .txt1 {
          font-size: 60px;
        }
        .txt2 {
          font-size: 36px;
          margin: 5px 0;
        }
        .txt3 {
          font-size: 50px;
        }
      }
      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
      .more {
        font-size: 20px;
        text-align: center;
        line-height: 50px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        cursor: pointer;
        padding: 0 30px;
        box-sizing: border-box;
        &:hover {
          background: #333333;
          color: #fff;
        }
      }
    }
  }
}
</style>